import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        setVisible(window.scrollY > 700);
      });
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
  return <div className={`fixed inset-x-0 bottom-5 z-50 flex justify-center px-6 transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-5 opacity-0'}`} aria-hidden={!visible} data-id="element-177" data-mp="3glqnvjogs5nu">
      <CtaButton href={CHECKOUT_URL} source="sticky" data-id="element-178" data-mp="gxpaeugtv11c" />
    </div>;
}